<section>
    <header *ngIf="isShowingHeader$ | async">
        <div class="app-title">
            <div class="logo">
                <img src="/assets/images/logos/tcat.png">
            </div>
            <span>Simplifying Business Travel</span>
        </div>
        <div *ngIf="session$ | async as session" class="account-container">
            <div class="right profile-icon" [popper]="myProfilePopover" [popperTrigger]="'click'"
                [popperPlacement]="'bottom'" [popperShowOnStart]="false" [popperDisableStyle]="true"
                [popperPositionFixed]="true" [popperApplyClass]="'profile-popover'">
                <i class="mdi mdi-dots-vertical right mrm"></i>
                <div class="image-container account rounded pointer">
                    <img alt="photo" *ngIf="session?.userProfile?.photoUrl != null; else noImage"
                        src="{{session?.userProfile?.photoUrl}}" />
                    <ng-template #noImage>
                        <i class="mdi mdi-account"></i>
                    </ng-template>
                </div>
            </div>
        </div>
    </header>
    <popper-content #myProfilePopover>
        <div *ngIf="session != null" class="my-profile-pane">
            <div class="arrow"></div>
            <div class="image-container mrl rounded pointer">
                <img alt="photo" *ngIf="session?.userProfile?.photoUrl != null; else noImage"
                    src="{{session?.userProfile?.photoUrl}}" />
                <ng-template #noImage>
                    <i class="no-img mdi mdi-account"></i>
                </ng-template>
            </div>
            <div class="profile-desc">
                <div class="row account-desc pointer ptm pbm">
                    <span class="col-12 account-name">{{session.displayName}}</span>
                    <span *ngIf="session?.userType! === 'CATALYCA'" class="col-12  fg-grey fs-12 ">Catalyca User</span>
                    <!-- <div>
                        <span class="left mrm  fg-grey fs-12 " *ngFor="let role of session?.roles!">{{role}}</span>
                    </div> -->
                    <div>
                        <span class="left mrm  fg-grey fs-12 ">
                            Active role : {{session?.activeRole | roleGroup}}
                        </span>
                    </div>
                </div>
                <div class="row brt ptm fs-12 bold pbm">
                    <span (click)="myProfilePopover.hide();logout($event)" class="right mlm logout-menu pointer">
                        <i class="mdi mdi-logout mrm"></i> Logout</span>
                    <span (click)="myProfilePopover?.hide();switchRole($event)" class="right mlm profile-menu pointer">
                        <i class="mdi mdi-pencil mrm"></i> Switch Role</span>
                </div>
            </div>
        </div>
    </popper-content>
</section>